import { Component, Input } from '@angular/core';
import { PagingRequest, IPage } from '../../../models/common/paging';
import { Configuration } from '../../../configuration';

@Component({
    selector: 'paging',
    template: require('./paging.component.html')
})
export class PagingComponent {
    constructor(private configuration: Configuration) {
    }
    
    @Input()
    request: PagingRequest;

    @Input()
    page: IPage<any>;

    @Input() pullRight = true;
    
    firstPage() {
        if (!this.isFirst()) {
            this.request.pageNumber = 0;
        }
    }

    nextPage() {
        if (!this.isLast()) {
            this.request.pageNumber++;
        }
    }
    
    previousPage() {
        if (!this.isFirst()) {
            this.request.pageNumber--;
        }
    }

    lastPage() {
        if (!this.isLast()) {
            this.request.pageNumber = this.page.totalPages - 1;
        }
    }

    isCurrent = (page: number) => this.request.pageNumber === page;

    selectPage(page: number) {
        if (!this.isCurrent(page)) {
            this.request.pageNumber = page;
        }
    }

    hasPrevious = () => this.request.pageNumber > 0;
    hasNext = () => (this.request.pageNumber + 1) < this.page.totalPages;
    isFirst = () => this.request.pageNumber === 0;
    isLast = () => this.request.pageNumber + 1 === this.page.totalPages;
    
    pageLinksToDisplay() {
        let min = Math.max(0, this.request.pageNumber - this.configuration.paging.selectedPositionBase);
        const pages :number[] = [],
            max = Math.min(min + this.configuration.paging.maxPageLinksToDisplay, this.page.totalPages);

        if (max === this.page.totalPages) {
            min = Math.max(0, this.page.totalPages - this.configuration.paging.maxPageLinksToDisplay);
        }
        for (let i = min; i < max; i++) {
            pages.push(i);
        }
        return pages;
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/search/paging.component.ts